import { ISbStoryData } from 'storyblok-js-client';

import { INVESTMENT_PROGRAM_COMPARISON_FIELDS } from '@monoimin/constants';

import { getStories } from './getStories';

import type { InvestmentProgramStoryblok } from '@monoimin/sb-types';

export const getInvestmentProgramNames = async (
  programs:
    | string
    | ISbStoryData<InvestmentProgramStoryblok>
    | (ISbStoryData<InvestmentProgramStoryblok> | string)[]
    | undefined
) => {
  if (!Array.isArray(programs)) {
    return [];
  }

  const uuids = programs.map((p) => (typeof p === 'string' ? p : p.uuid));

  if (uuids.length === 0) {
    return [];
  }

  const {
    data: { stories },
  } = await getStories<InvestmentProgramStoryblok>({
    by_uuids: uuids.join(','),
    version: 'published',
    excluding_fields: INVESTMENT_PROGRAM_COMPARISON_FIELDS,
  });

  const programsName = stories.reduce<Array<string>>((acc, program) => {
    if (
      program &&
      typeof program !== 'string' &&
      typeof program?.content?.programName === 'string'
    ) {
      acc.push(String(program.content.programName));
    }
    return acc;
  }, []);

  return programsName.length === 1 ? programsName[0] : programsName;
};
